__turbopack_context__.v({
  "contributor": "Contributor-module-scss-module__tA4svW__contributor",
  "contributor__additional": "Contributor-module-scss-module__tA4svW__contributor__additional",
  "contributor__email": "Contributor-module-scss-module__tA4svW__contributor__email",
  "contributor__email_name": "Contributor-module-scss-module__tA4svW__contributor__email_name",
  "contributor__image": "Contributor-module-scss-module__tA4svW__contributor__image",
  "contributor__subrole": "Contributor-module-scss-module__tA4svW__contributor__subrole",
  "contributor__title": "Contributor-module-scss-module__tA4svW__contributor__title",
});
